import React from 'react'

function AboutUS() {
    return (
        <div style={{ backgroundColor: " #fef7e7", border: "2px solid DarkGoldenRod", margin: "20px 0 20px", padding: "20px" }}>
            <h1>ABOUT US</h1>
            The bicycle industry or cycling industry can broadly be defined as the industry concerned with bicycles and cycling. It includes at least bicycle manufacturers, part or component manufacturers, and accessory manufacturers. It can also include distributors, retailers, bicycle organizations, bicycle event promoters, and bicycle related service providers.

            The Global Bicycle Industry generates sales for over $45 bn in 2017 and is forecasted, according to analyst consensus, at 6-0% p.a. over the next 5yr

            In 2016 in the United States, it generated $6 billion of revenueand in Europe, it generated €14 bn in revenues.

        </div>
    )
}

export default AboutUS
